import React from "react";

const RefundPolicy = () => {
  const headingClasses = `font-bold text-3xl my-12`;
  const headingClassesH2 = `font-bold text-2xl my-5`;
  const headingClassesH3 = `font-semibold text-2xl my-5`;
  const liClasses = ` ml-10 list-disc`;
  const pTagClasses = `text-sm mb-5`;

  React.useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <div className="flex flex-1 flex-col bg-white py-16 pt-5 px-5 xl:px-52 lg:px-32 md:px-16 sm:px-8">
      <h1 className={`font-bold text-2xl mb-5`}>Return and Refund Policy for Player Turf</h1>
      <div className='border border-gray-200 w-full mb-10' />
      <h1 className={`${headingClasses} mt-0 text-4xl`}>
        Return and Refund Policy
      </h1>
      <p className={`${pTagClasses} text-gray-500`}>
        Last updated: December 17, 2024
      </p>
      <p className={`${pTagClasses}`}>
        The following terms are applicable for any service that You purchased
        with Us.
      </p>
      <h2 className={`${headingClasses}`}>Interpretation and Definitions</h2>
      <h3 className={`${headingClassesH3} mt-0`}>Interpretation</h3>
      <p className={`${pTagClasses}`}>
        The words of which the initial letter is capitalized have meanings
        defined under the following conditions. The following definitions shall
        have the same meaning regardless of whether they appear in singular or
        in plural.
      </p>
      <h3 className={`${headingClassesH3}`}>Definitions</h3>
      <p className={`${pTagClasses} pb-0`}>
        For the purposes of this Return and Refund Policy:
      </p>
      <ul>
        <li className={`${liClasses}`} >
          <p className={`${pTagClasses}`}>
            <strong>Company</strong> (referred to as either &quot;the
            Company&quot;, &quot;We&quot;, &quot;Us&quot; or &quot;Our&quot; in
            this Agreement) refers to Players Turf, A-103, SATELLITE PARK CHS
            LTD, CAVES ROAD, JOGESHWARI EAST, Mumbai City, Maharashtra, 400060.
          </p>
        </li>
        <li className={`${liClasses}`} >
          <p className={`${pTagClasses}`}>
            <strong>Goods</strong> refer to the items offered for sale on the
            Service.
          </p>
        </li>
        <li className={`${liClasses}`} >
          <p className={`${pTagClasses}`}>
            <strong>Orders</strong> mean a request by You to purchase service(s) from
            Us.
          </p>
        </li>
        {/* <li className={`${liClasses}`} >
          <p className={`${pTagClasses}`}>
            <strong>Service</strong> refers to the Website.
          </p>
        </li> */}
        {/* <li className={`${liClasses}`} >
          <p className={`${pTagClasses}`}>
            <strong>Website</strong> refers to Players Turf, accessible from{" "}
            <a
              href="https://playersturf.co.in/"
              rel="external nofollow noopener"
              target="_blank"
            >
              https://playersturf.co.in/
            </a>
          </p>
        </li> */}
        <li className={`${liClasses}`} >
          <p className={`${pTagClasses}`}>
            <strong>You</strong> means the individual accessing or using the
            Service, or the company, or other legal entity on behalf of which
            such individual is accessing or using the Service, as applicable.
          </p>
        </li>
      </ul>
      <h2 className={`${headingClassesH2}`}>Your Order Cancellation Rights</h2>
      <p className={`${pTagClasses}`}>
        You are entitled to cancel Your Order within 7 days without giving any
        reason for doing so.
      </p>
      <p className={`${pTagClasses}`}>
        The deadline for cancelling an Order is 7 days from the date on which
        You received the Goods or on which a third party you have appointed, who
        is not the carrier, takes possession of the product delivered.
      </p>
      <p className={`${pTagClasses}`}>
        In order to exercise Your right of cancellation, You must inform Us of
        your decision by means of a clear statement. You can inform us of your
        decision by:
      </p>
      <ul>
        <li className={`${liClasses}`} >
          <p className={`${pTagClasses}`}>By email: playersturf2020@gmail.com</p>
        </li>
        <li className={`${liClasses}`} >
          <p className={`${pTagClasses}`}>By phone number: +91 8181810872</p>
        </li>
      </ul>
      <p className={`${pTagClasses}`}>
        We will reimburse You no later than 14 days from the day on which We
        receive the returned Goods. We will use the same means of payment as You
        used for the Order, and You will not incur any fees for such
        reimbursement.
      </p>
      <h2 className={`${headingClassesH2}`}>Conditions for Returns</h2>
      <p className={`${pTagClasses}`}>
        In order for the Goods to be eligible for a return, please make sure
        that:
      </p>
      <ul>
        <li className={`${liClasses}`} >The Goods were purchased in the last 7 days</li>
        <li className={`${liClasses}`} >The Goods are in the original packaging</li>
      </ul>
      <p className={`${pTagClasses} mt-4 `}>The following Goods cannot be returned:</p>
      <ul>
        <li className={`${liClasses}`} >
          The supply of Goods made to Your specifications or clearly
          personalized.
        </li>
        <li className={`${liClasses}`} >
          The supply of Goods which according to their nature are not suitable
          to be returned, deteriorate rapidly or where the date of expiry is
          over.
        </li>
        <li className={`${liClasses}`} >
          The supply of Goods which are not suitable for return due to health
          protection or hygiene reasons and were unsealed after delivery.
        </li>
        <li className={`${liClasses}`} >
          The supply of Goods which are, after delivery, according to their
          nature, inseparably mixed with other items.
        </li>
      </ul>
      <p className={`${pTagClasses}`}>
        We reserve the right to refuse returns of any merchandise that does not
        meet the above return conditions in our sole discretion.
      </p>
      <p className={`${pTagClasses}`}>
        Only regular priced Goods may be refunded. Unfortunately, Goods on sale
        cannot be refunded. This exclusion may not apply to You if it is not
        permitted by applicable law.
      </p>
      <h2 className={`${headingClassesH2}`}>Returning Goods</h2>
      <p className={`${pTagClasses}`}>
        You are responsible for the cost and risk of returning the Goods to Us.
        You should send the Goods at the following address:
      </p>
      <p className={`${pTagClasses}`}>
        A-103, SATELLITE PARK CHS LTD, CAVES ROAD,
        <br />
        JOGESHWARI EAST, Mumbai City, Maharashtra, 400060
      </p>
      <p className={`${pTagClasses}`}>
        We cannot be held responsible for Goods damaged or lost in return
        shipment. Therefore, We recommend an insured and trackable mail service.
        We are unable to issue a refund without actual receipt of the Goods or
        proof of received return delivery.
      </p>
      {/* <h2 className={`${headingClassesH2}`}>Gifts</h2>
      <p className={`${pTagClasses}`}>
        If the Goods were marked as a gift when purchased and then shipped
        directly to you, You'll receive a gift credit for the value of your
        return. Once the returned product is received, a gift certificate will
        be mailed to You.
      </p>
      <p className={`${pTagClasses}`}>
        If the Goods weren't marked as a gift when purchased, or the gift giver
        had the Order shipped to themselves to give it to You later, We will
        send the refund to the gift giver.
      </p> */}
      <h3 className={`${headingClassesH3}`}>Contact Us</h3>
      <p className={`${pTagClasses}`}>
        If you have any questions about our Returns and Refunds Policy, please
        contact us:
      </p>
        
      <ul className={`${liClasses}`}>
        <li>By email: <a href="mailto:playersturf2020@gmail.com" className="hyperlink">playersturf2020@gmail.com</a></li>
        <li>By phone number: +91 8181810872</li>
      </ul>
    </div>
  );
};

export default RefundPolicy;
